// @flow
import React, { Component } from 'react'
import Tr from '../../../../components/Tr'
import Td from '../../../../components/Td'

type Props = {
  value: string,
  label: string,
  name: string,
  onUpdate: Function
}

type State = {
  value: string
}

class AdminOfferFormRow extends Component {
  constructor(props: Props) {
    super(props)
    this.state = {
      value: this.props.value
    }
  }

  state: State
  props: Props

  handleUpdate = (e: any) => {
    const value = e.target.value
    this.setState({ value })
    this.props.onUpdate({ offer: { [this.props.name]: value } })
  }

  render() {
    const { label, name } = this.props

    return (
      <Tr>
        <Td>{label}</Td>
        <Td style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <select
            name={name}
            value={this.state.value}
            className="form-control"
            style={{ width: '200px' }}
            onChange={this.handleUpdate}
          >
            <option value="Pending">Pending</option>
            <option value="Review">Review</option>
            <option value="Completed">Completed</option>
          </select>
        </Td>
      </Tr>
    )
  }
}

export default AdminOfferFormRow



// WEBPACK FOOTER //
// ./src/views/AdminUserOffers/components/AdminOfferFormRow/index.js